import React, { useEffect, createElement } from 'react';
import { useMetaPixel } from './hooks/useMetaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { PainPointSection } from './components/PainPointSection';
import { AchievementsSection } from './components/AchievementsSection';
import { WhyUseSection } from './components/WhyUseSection';
import { TestimonialSection } from './components/TestimonialSection';
import { ProductShowcase } from './components/ProductShowcase';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { UrgencySection } from './components/UrgencySection';
import { CreatorSection } from './components/CreatorSection';
import { ReviewsSection } from './components/ReviewsSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  useMetaPixel();
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-partyPink-light selection:text-partyPink-hot" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainPointSection data-id="element-3" />
      <AchievementsSection data-id="element-4" />
      <WhyUseSection data-id="element-5" />
      <TestimonialSection data-id="element-6" />
      <ProductShowcase data-id="element-7" />
      <BonusSection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <UrgencySection data-id="element-10" />
      <CreatorSection data-id="element-11" />
      <ReviewsSection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}